const eventCenter = {
    getCallBackName (type) {
        return `_${type}_cb`
    },
    event: {
        reply (res) {
            eventCenter.send(eventCenter.getCallBackName(this.type), res)
        }
    },
    sub (type, mesCallback, single = true) {
        this.argus = this.argus || {}
        this.argus[type] = this.argus[type] || []
        if(single === false){
            this.argus[type].push(mesCallback)
        }
        else {
            this.argus[type] = [ mesCallback ]
        }

    },
    pub () {
        // eslint-disable-next-line prefer-rest-params
        const args = Array.prototype.slice.call(arguments, 0)
        const type = args.shift()
        if (!this.argus || !this.argus[type]) {
            return this
        }
        for (let i = 0; i < this.argus[type].length; i++) {
            const event = Object.assign({}, this.event);
            event.type = type
            args.push(event)
            this.argus[type][i].apply(this, args)
        }
    },
    registerSend (fn, blockExec = true) {
        if (typeof fn === 'function') {
            this.send = (type, data, cb) => {
                if (typeof cb === 'function') {
                    this.subCallback(this.getCallBackName(type), res => {
                        cb(res)
                    })
                }
                if(blockExec){
                    setTimeout(()=>{
                        fn({ eventData: { type, data } })
                    }, 0)
                }else{
                    fn({ eventData: { type, data } })
                }
            }
        }
    },
    registerPubTrigger (state) {
        this.pub(state.eventData.type, state.eventData.data)
    },
    subCallback (type, cb) {
        this.argus = this.argus || {}
        this.argus[type] = this.argus[type] || []
        this.argus[type] = [cb]
    }
}
export { eventCenter }
